import { render, staticRenderFns } from "./w-select.vue?vue&type=template&id=c37cadac&"
import script from "./w-select.vue?vue&type=script&lang=ts&"
export * from "./w-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports